const common = {
    authNavBarRegister: String("Sign in"),
    authNavBarLogin: String("Log in"),
};

export default common;